// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__ccWHM","vLegacy":"SelectSecondary_vLegacy__2qaXc","error":"SelectSecondary_error__1_RJ9","disabled":"SelectSecondary_disabled__D9LiU"};